export function niceDomain(values: number[], pad = 5): [number, number] {
  const xs = values.filter((v) => Number.isFinite(v));
  if (xs.length === 0) return [0, 100];
  let lo = Math.floor((Math.min(...xs) - pad) / 10) * 10;
  let hi = Math.ceil((Math.max(...xs) + pad) / 10) * 10;
  if (hi - lo < 20) { const mid = Math.round((lo + hi) / 20) * 10; lo = mid - 10; hi = mid + 10; }
  return [Math.max(0, lo), Math.min(100, hi)];
}

export const scale = (d0: number, d1: number, r0: number, r1: number) =>
  (v: number) => (d1 === d0 ? (r0 + r1) / 2 : r0 + ((v - d0) / (d1 - d0)) * (r1 - r0));

const r = (n: number) => Math.round(n * 10) / 10;

export function smoothPath(pts: [number, number][]): string {
  if (pts.length === 0) return '';
  let d = `M${r(pts[0][0])},${r(pts[0][1])}`;
  for (let i = 1; i < pts.length; i++) {
    const [x0, y0] = pts[i - 1]; const [x1, y1] = pts[i]; const cx = r((x0 + x1) / 2);
    d += ` C${cx},${r(y0)} ${cx},${r(y1)} ${r(x1)},${r(y1)}`;
  }
  return d;
}

export function segments(values: (number | null)[]): { i: number; v: number }[][] {
  const out: { i: number; v: number }[][] = []; let cur: { i: number; v: number }[] = [];
  values.forEach((v, i) => {
    if (v == null || !Number.isFinite(v)) { if (cur.length) out.push(cur); cur = []; }
    else cur.push({ i, v });
  });
  if (cur.length) out.push(cur);
  return out;
}
